<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-data-table
    :headers="getApplicationHeaders ()"
    :items="getItems ()"
    :loading="applicationLoading"
    :items-per-page="rowsPerPage"
    :total-items="rowCount"
    :no-data-text="$t('krita.datagrid.nodata')"
    hide-actions
  >
    <template v-slot:headers="props">
      <data-grid-sort
        :props="props"
        :pagination="pagination"
        @changeSort="changeSort"
      />
    </template>
    <template v-slot:items="props">
      <tr @click="navigateToApplicationDetail(props.item.id)">
        <td class="text-xs-left"><router-link
          :to="{name: 'Application detail', params: {id: props.item.id}}" 
          target="_self">{{ props.item.id }}</router-link></td>
        <td class="text-xs-left">{{ props.item.status }}</td>
        <td class="text-xs-left">{{ props.item.claimCount }}</td>
        <td class="text-xs-left">{{ props.item.capital | amount }}</td>
        <td class="text-xs-left">{{ props.item.initialTransferAmount | amount }}</td>
        <td class="text-xs-left">{{ props.item.created | date }}</td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import DataGridSort from '../../controllers/DataGridSort'
import EnumIterator from '../../helper/EnumIterator';
    export default {
        components: {DataGridSort},
        props: ['applicationReportData','applicationLoading','rowsPerPage','rowCount'],
        data () {
            return {
                pagination:
                    {
                        sortBy: 'id'
                    }
            }
        },
        methods: {
            getApplicationHeaders ()
            {
                return [
                    {sortable: true, text: this.$t('krita.reports.application.header.id'), value: 'id', align: 'left'},
                    {sortable: true, text: this.$t('krita.reports.application.header.status'), value: 'status', align: 'left'},
                    {sortable: false, text: this.$t('krita.reports.application.header.numberofclaims'), value: 'count', align: 'left'},
                    {sortable: true, text: this.$t('krita.reports.application.header.capital'), value: 'totalAmount', align: 'left'},
                    {sortable: false, text: this.$t('krita.reports.application.header.initialtransferamount'), value: 'initialTransferAmount', align: 'left'},
                    {sortable: true, text: this.$t('krita.reports.application.header.created'), value: 'created', align: 'left'},
                ]
            },
            getItems ()
            {
              let self = this;

              let items = [];
              for (let applicationReport of self.applicationReportData)
              {
                let applicationReportClient = {
                  id: applicationReport.id,
                  status: self.$t(EnumIterator.processApplicationStatus(applicationReport.status)),
                  claimCount: applicationReport.claimCount,
                  capital: applicationReport.capital,
                  initialTransferAmount: applicationReport.initialTransferAmount,
                  created: applicationReport.created
                };
                items.push(applicationReportClient);
              }
              return items;
            },
            navigateToApplicationDetail (id)
            {
                let self = this;

                self.$router.push('/application/' + id);
            },
          changeSort (sort)
          {
              let self = this;

              self.pagination.sortBy = sort.sortBy;
              self.pagination.descending = sort.descending;
              self.$emit('refreshWithSort',self.pagination);
          },
          sortItems (items)
          {
            let self = this;

            self.items = items;
          }
        }
    }
</script>
